// extracted by mini-css-extract-plugin
module.exports = {"root":"WorkflowButton_root__3xdwf","btn":"WorkflowButton_btn__zJih0","hidden":"WorkflowButton_hidden__3v6RE"};